<template>
  <div
    v-if="validNotifications.some((n) => n.notice)"
    class="notifications-area"
    :class="device"
  >
    <div v-for="(n, i) in validNotifications" :key="i">
      <p v-if="n.notice">
        {{ "・" + n.notice }}
        <span v-if="n.url" @click="goToExternalLink(n.url)"
          >詳しくはこちら</span
        >
      </p>
    </div>
  </div>
</template>

<script>
import moment from "@/services/moment";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

export default {
  name: "TheNotificationsArea",
  props: {
    notifications: { type: Object, required: true, default: null },
  },
  setup(props) {
    const store = useStore();
    const device = computed(() => store.getters["common/device"]);
    const validNotifications = ref([]);

    const isInPeriod = (notification) => {
      const now = moment(new Date());
      return now.isAfter(notification.start_date) &&
        now.isBefore(notification.end_date)
        ? true
        : false;
    };

    onMounted(() => {
      validNotifications.value = props.notifications.filter((notification) =>
        isInPeriod(notification)
      );
    });

    return {
      validNotifications,
      device,
    };
  },
};
</script>

<style lang="scss" scoped>
.notifications-area {
  margin: 2% 0 5% 0;
  background: #fff2ec;
  color: #ed4451;
  font-weight: bold;
  padding: 2% 4%;
}

.IOS {
  margin-top: 3%;
}

p {
  font-size: 3vw;
  line-height: 20px;
  display: block;
  width: 100%;
  padding: 3% 0 3% 0;
}

p:nth-child(2) {
  margin-top: 2%;
}

span {
  text-decoration: underline;
}
</style>
